import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import reducers from "./reducers";
import "./styles/index.css";
import App from "./App";

const loggerMiddleware = createLogger();

ReactDOM.render(
  <Provider
    store={createStore(
      reducers,
      applyMiddleware(thunkMiddleware, loggerMiddleware)
    )}
  >
    <App />
  </Provider>,
  document.getElementById("root")
);

// change new



// WEBPACK FOOTER //
// ./src/index.js